export default __webpack_public_path__ + "static/media/write.299b7c39.svg";